var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M65,14.9 L92.9,22.6 C96.1,23.7 98.6,26.1 100,29.2 L100,39 L0,39 L0,29.2 C1.3,26.1 3.9,23.7 7.1,22.6 L35,14.9 L35,0 L65,0 L65,14.9 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,14.9 L92.9,22.6 C96.1,23.7 98.6,26.1 100,29.2 L100,39 L0,39 L0,29.2 C1.3,26.1 3.9,23.7 7.1,22.6 L35,14.9 L35,0 L65,0 L65,14.9 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,14.9 L92.9,22.6 C96.1,23.7 98.6,26.1 100,29.2 L100,39 L0,39 L0,29.2 C1.3,26.1 3.9,23.7 7.1,22.6 L35,14.9 L35,0 L65,0 L65,14.9 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_male_628288",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65,65.9 L92.9,73.6 C96.1,74.7 98.6,77.1 100,80.2 L100,90 L0,90 L0,80.2 C1.3,77.1 3.9,74.7 7.1,73.6 L35,65.9 L35,51 L65,51 L65,65.9 Z",
    id: "Path",
    fill: "#C9C9C9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-3 L100,-3 L100,39 L0,39 L0,-3 Z M50,27 C61,27 70,20.7 70,13 C70,5.3 61,-1 50,-1 C39,-1 30,5.3 30,13 C30,20.7 39,27 50,27 Z",
    id: "Shape",
    fill: "#BABABA",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,17 C48.3,17 46.1,16.6 44.6,15.9 C42.9,15 36.6,9.8 34.4,7.6 C31.6,4.6 30.2,0.8 29.8,-5.7 C29.4,-12.2 27.7,-35.4 27.7,-40.7 C27.7,-48.2 33.4,-59.9 49.8,-59.9 L49.9,-59.9 L49.9,-59.9 L49.9,-59.9 L50,-59.9 C66.5,-59.8 72.1,-48.2 72.1,-40.7 C72.1,-35.4 70.4,-12.2 70,-5.7 C69.6,0.8 68.2,4.5 65.4,7.6 C63.3,9.9 57,15 55.2,15.9 C53.9,16.6 51.7,17 50,17 L50,17 Z",
    id: "Path",
    fill: "#B8B8B8",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,-3 C37.3,-3 27,4.4 27,13.5 C27,22.6 37.3,30 50,30 C62.7,30 73,22.6 73,13.5 C73,4.4 62.7,-3 50,-3 Z M50,26 C39.5,26 31,20 31,12.5 C31,5 39.5,-1 50,-1 C60.5,-1 69,5 69,12.5 C69,20 60.5,26 50,26 Z",
    id: "Shape",
    fill: "#D5D5D5",
    fillRule: "nonzero",
    mask: "url(#mask-6)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M50,64 C48.5,64 46.5,63.7 45.2,63.1 C43.6,62.4 38,58.5 36.1,56.8 C33.6,54.5 32.3,51.7 31.9,46.8 C31.5,41.9 30,24.5 30,20.5 C30,14.8 35.1,6 50,6 L50,6 L50,6 L50,6 L50,6 C64.9,6 70,14.8 70,20.5 C70,24.5 68.5,42 68.1,46.9 C67.7,51.8 66.5,54.6 63.9,56.9 C62,58.6 56.3,62.5 54.8,63.2 C53.5,63.7 51.5,64 50,64 L50,64 Z",
    id: "Path",
    fill: "#DADADA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8,38.2 C68.8,38.2 69.6,31.9 72.5,31 C72.9,29.2 74,24 74,21.1 C74,18.2 73.7,15.4 72.1,13 C70.3,10.4 66.5,8.9 64.5,8.9 C62.2,10.3 56.8,13.5 55.1,15.4 C54.2,16.4 55.5,17.2 55.5,17.2 C55.5,17.2 56.7,16.7 57.2,16.6 C59.7,15.9 65.2,15.4 66.9,17.9 C69,20.9 69,29.7 69,31 C69,32.2 68.8,38.2 68.8,38.2 Z",
    id: "Path",
    fill: "#535353",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,31 C30.4,32 31.2,38.2 31.2,38.2 C31.2,38.2 31,32.2 31,31 C31,29.4 31.2,21.9 34.4,18.3 C38,14.3 42.8,13 45.5,14.8 C46.9,15.7 51.6,20.3 56.6,16.5 C59.6,14.2 65.1,9 65.1,9 C65.1,9 62.2,0.1 49,1.1 C43.4,1.6 37.2,0.2 37.2,0.2 C37.2,0.2 37.1,2.7 38.1,4 C29.8,6.4 27.1,12.4 26.3,17 C26.1,17.9 26,18.8 26,19.7 C26,20.2 26,20.7 26,21.1 C26,24 27.1,29.1 27.5,31 Z",
    id: "Path",
    fill: "#707070",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.20c5b7e04c36319df2d992d6403790b8.svg";
export { ForwardRef as ReactComponent };